<template>
<v-menu v-model='visible' :close-on-content-click='false' >
  <template v-slot:activator="{ on }">
  <v-btn v-on='on' slot='activator' small icon class='hidden-xs-only' >
    <v-icon>settings</v-icon>
  </v-btn>
  </template>
  <v-card>
    <v-card-title class='subtitle-1 overline py-2' >
      Calendar settings
      <v-spacer></v-spacer>
      <v-btn small icon
        @click='visible=false'
        class='mr-0' ><v-icon small>close</v-icon></v-btn>
    </v-card-title>
    <v-divider ></v-divider>
    <v-list v-for='option in options' :key='option.value' dense >
      <v-subheader class='overline' >{{option.text}}</v-subheader>
      <v-list-tile
        v-for='item in option.items'
        :key='item.value'
        @click='setItem(option.value, item.value)' >
        <v-list-tile-avatar v-if='settings[option.value] === item.value' >
          <v-icon >check</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-avatar v-else >
          <v-icon >check_box_outline_blank</v-icon>
        </v-list-tile-avatar>
        <v-list-tile-content>
          <v-list-tile-title>{{item.text}}</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
    </v-list>
  </v-card>
</v-menu>
</template>
<script>
import Vue from 'vue'
const SETTINGS_KEY = 'ag.calendar.settings'
export default {
  name: 'CalendarSettings',
  props: {
    value: { type: Object, default: () => { return {} } }
  },
  data () {
    return {
      visible: false,
      settings: {
        density: 1
      },
      options: [
        {
          text: 'Density',
          value: 'density',
          items: [
            { text: 'Compact', value: 1 },
            { text: 'Comfortable', value: 2 },
            { text: 'Max spacing', value: 3 }
          ]
        },
        {
          text: 'Days to show',
          value: 'numDays',
          items: [
            { text: 'Auto', value: null },
            { text: '4', value: 4 },
            { text: '5', value: 5 },
            { text: '7', value: 7 }
          ]
        }
      ]
    }
  },
  mounted () {
    let settings = Vue.$cookies.get(SETTINGS_KEY)
    if (settings) {
      this.$emit('input', settings)
    }
  },
  watch: {
    value () {
      if (this.value) { this.settings = this.value }
    },
    settingsString () {
      Vue.$cookies.set(SETTINGS_KEY, this.settings)
      if (window.localStorage) {
        window.localStorage.setItem(SETTINGS_KEY, this.settingsString)
        // may need to access storage in order to persist it.
        window.localStorage.getItem(SETTINGS_KEY)
      }
    }
  },
  methods: {
    setItem (key, value) {
      Vue.set(this.settings, key, value)
      this.$emit('input', this.settings)
    }
  },
  computed: {
    settingsString () {
      return JSON.stringify(this.settings)
    }
  }
}
</script>



// WEBPACK FOOTER //
// CalendarSettings.vue?a4f292ba